import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const userStore = create(
  persist(
    (set) => ({
      userName: "",
      userId: null,
      sessionId: null,
      isSuperUser: false,
      tokenReady: false,
      userAssociatedCustomerGroups: [],
      setUserName: (newName) => set({ userName: newName }),
      setUserId: (newId) => set({ userId: newId }),
      setSessionId: (newId) => set({ sessionId: newId }),
      setIsSuperUser: (isSuperUser) => set({ isSuperUser }),
      setTokenReady: (ready) => set({ tokenReady: ready }),
      setUserAssociatedCustomerGroups: (newGroups) =>
        set({ userAssociatedCustomerGroups: newGroups }),
    }),
    {
      name: "userName-storage",
      storage: createJSONStorage(() => sessionStorage),
      // tokenReady is runtime-only liveness state. Persisting it would make it
      // rehydrate as `true` after a page refresh before any token has actually
      // been acquired, causing consumers to fire authenticated calls too early.
      partialize: ({ tokenReady, ...rest }) => rest, // eslint-disable-line no-unused-vars
    }
  )
);

export default userStore;
